import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
import { AccessibilityWidget } from './components/AccessibilityWidget';
import { CookieBanner } from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceDetail } from './pages/ServiceDetail';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Contact } from './pages/Contact';
import { Cart } from './pages/Cart';
import { AppointmentPage } from './pages/AppointmentPage';
import { PersonalRx } from './pages/PersonalRx';
import { AccessibilityStatement } from './pages/AccessibilityStatement';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCalendar from './pages/admin/AdminCalendar';
import AdminServices from './pages/admin/AdminServices';
import AdminClients from './pages/admin/AdminClients';
import AdminAppointments from './pages/admin/AdminAppointments';
import AdminBundles from './pages/admin/AdminBundles';
import AdminProducts from './pages/admin/AdminProducts';
import AdminShopServices from './pages/admin/AdminShopServices';
import AdminPersonalRx from './pages/admin/AdminPersonalRx';
import AdminOrders from './pages/admin/AdminOrders';
import AdminContacts from './pages/admin/AdminContacts';
import AdminPolicies from './pages/admin/AdminPolicies';
import AdminReels from './pages/admin/AdminReels';
import AdminGiftCards from './pages/admin/AdminGiftCards';
import AdminGiftCardPreview from './pages/admin/AdminGiftCardPreview';
import GiftCardPurchase from './pages/GiftCardPurchase';
import GiftCardView from './pages/GiftCardView';
import Policy from './pages/Policy';
import HealthFormPublic from './pages/HealthFormPublic';
import AdminHealthForms from './pages/admin/AdminHealthForms';

import { CartProvider } from './context/CartContext';
import { ContentProvider } from './context/ContentContext';

function App() {
  return (
    <CartProvider>
      <ContentProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            {/* Standalone recipient experience — deliberately outside the site chrome. */}
            <Route path="/gift/:token" element={<GiftCardView />} />
            <Route path="/health-form" element={<HealthFormPublic />} />
            <Route path="/health-form/new" element={<HealthFormPublic />} />
            <Route path="/health-form/:token" element={<HealthFormPublic />} />

            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="appointments" element={<AdminAppointments />} />
              <Route path="bundles" element={<AdminBundles />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="shop-services" element={<AdminShopServices />} />
              <Route path="personal-rx" element={<AdminPersonalRx />} />
              <Route path="health-forms" element={<AdminHealthForms />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="contacts" element={<AdminContacts />} />
             <Route path="policies" element={<AdminPolicies />} />
             <Route path="reels" element={<AdminReels />} />
             <Route path="gift-cards" element={<AdminGiftCards />} />
             <Route path="gift-cards/preview" element={<AdminGiftCardPreview />} />
            </Route>
            <Route
              path="*"
              element={
                <div className="w-full bg-[#412018] min-h-[100dvh] flex flex-col">
                  <a
                    href="#main-content"
                    className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:right-3 focus:z-[100] focus:bg-[#fbbf25] focus:text-[#412018] focus:px-4 focus:py-2 focus:rounded focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#412018]"
                  >
                    דלג לתוכן הראשי
                  </a>
                  <Navbar />
                  <main id="main-content" tabIndex={-1} className="flex-grow focus:outline-none">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/services" element={<ServicesPage />} />
                      <Route path="/services/:id" element={<ServiceDetail />} />
                      <Route path="/shop" element={<Shop />} />
                      <Route path="/shop/:id" element={<ProductDetail />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/cart" element={<Cart />} />
                      <Route path="/appointment" element={<AppointmentPage />} />
                      <Route path="/personal-rx" element={<PersonalRx />} />
                      <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
                      <Route path="/gift-card" element={<GiftCardPurchase />} />
                      <Route path="/policies/:handle" element={<Policy />} />
                    </Routes>
                  </main>
                  <Footer />
                  <CartDrawer />
                  <AccessibilityWidget />
                  <CookieBanner />
                </div>
              }
            />
          </Routes>
        </Router>
      </ContentProvider>
    </CartProvider>
  );
}

export default App;
